import styled, { css } from 'styled-components';

export const TitleMixin = css`
  display: block;
`;

export const SmallerMarginMixin = css`
  .panda-input-dropdown {
    margin-bottom: 8px;
  }
`;

export const DraggableItem = styled.div`
  position: absolute;
  height: 50px;
  width: 100%;
`;

export const DraggableContainer = styled.div<{ numItems: number }>`
  position: relative;
  height: ${(props) => props.numItems * 50}px;
`;
